import React, { useEffect, useState } from "react";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ButtonInfo from "../common/button/ButtonInfo";
import AppIcons from "../../utils/AppIcons";
import Pilot from "../../model/Pilot";
import { useApiClient } from "../../contexts/ApiClientContext";
import {User} from "../../model/User";
import APIEndPoints from "../../utils/APIEndPoints";
import Site from "../../model/Site";
import PagedData from "../../model/PagedData";
import Loading from "../common/Loading";
import Client from "../../model/ClientSSO";

interface IClientsListElementProps {
  data: Client;
  canView: boolean;
}

function ClientsListElement({ data, canView }: IClientsListElementProps) {
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // user that created the pilot
  const [username, setUsername] = useState<string>();
  // number of associated sites
  const [numberOfSites, setNumberOfSites] = useState<number>();
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {

    apiClient
      ?.get<PagedData<Client[]>>({
        url: APIEndPoints.CLIENTS.ALL,
        requiresToken: true,
      })
      .then((sites: PagedData<Client[]>) => {
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [apiClient]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div
      className="p-4 border border-solid border-gray-200 rounded-xl mx-32 my-5 text-gray-600 hover:bg-blue-50 cursor-pointer"
      onClick={() => {
        navigate(
          SETTINGS.get_path({
            section: AppSections.CLIENTS,
            id: data.id,
            subsection: AppSubSections.VIEW,
          })
        );
      }}
    >
      <div className="flex justify-between">
        <div className="flex-grow">
          <h3 className="text-left">{data.client_metadata.client_name}</h3>
        </div>
        {canView && (
          <Button
            label="Edit"
            purpose={ButtonAction.EDIT}
            type={ButtonType.ICON_TEXT}
            onClick={() =>
              navigate(
                SETTINGS.get_path({
                  section: AppSections.CLIENTS,
                  id: data.id,
                  subsection: AppSubSections.EDIT,
                })
              )
            }
          />
        )}

      </div>

      {canView && (
        <div className="flex">
          <div className="flex justify-between">
            <div className="p-2">
              URI: 
            </div>
            <div className="p-2 text-blue-500">
              {data.client_metadata.client_uri}
            </div>
          </div>
          {/* <div className="flex-grow">
            <div className="text-left">ClientSSO URI: {data.client_metadata.client_uri}</div>
          </div> */}
        </div>
      )}


    </div>
  );
}

export default ClientsListElement;
